import React, { useContext, useEffect } from "react";

/// React router dom
import { Switch, Route } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import { ThemeContext } from "../context/ThemeContext";
import AddTransaction from "./components/Dashboard/components/AddTransaction";
import Transaction from "./components/Dashboard/components/Transaction";
import ViewTransaction from "./components/Dashboard/components/ViewTransaction";
import Companies from "./components/Companies/Companies";
import Departments from "./components/Departments/Departments";
const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  let routes = []
  localStorage.getItem("privilege") === "user" ? routes = [
    /// Dashboard
    { url: "", component: AddTransaction },
    { url: "add-transaction", component: AddTransaction },
    { url: "view-transactions", component: ViewTransaction }
  ] :
    routes = [
      { url: "", component: AddTransaction },
      { url: "add-transaction", component: AddTransaction },
      { url: "view-transactions", component: ViewTransaction },
      { url: "review-transactions", component: Transaction },
      { url: "manage-departments", component: Departments },
      { url: "companies", component: Companies }
    ]

  let pagePath = path.split("-").includes("page");
  return (
    <>
      <div
        id="main-wrapper"
        className={`${menuToggle ? "show menu-toggle" : "show"
          }`}
      >
        <Nav />

        <div className="content-body">
          <div
            className="container-fluid"

          >

            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Markup;
